export const comicCategories = [
  {
    id: "rexue",
    name: "热血",
    subtitle: "少年与战斗",
    icon: "ri-fire-line",
    description: "热血格斗、成长蜕变与信念碰撞，燃烧每一页的少年气。",
  },
  {
    id: "lianai",
    name: "恋爱",
    subtitle: "心动与告白",
    icon: "ri-heart-line",
    description: "从暗恋到双向奔赴，收录细腻又心动的高糖恋爱漫画。",
  },
  {
    id: "qihuan",
    name: "奇幻",
    subtitle: "异世界与魔法",
    icon: "ri-magic-line",
    description: "魔法、妖怪与异世界冒险，打开想象力的另一扇门。",
  },
  {
    id: "dushi",
    name: "都市",
    subtitle: "现实与烟火",
    icon: "ri-building-2-line",
    description: "城市生活里的挣扎与温柔，写实笔触描绘人间百态。",
  },
  {
    id: "xuanyi",
    name: "悬疑",
    subtitle: "谜案与真相",
    icon: "ri-search-eye-line",
    description: "层层反转的谜题与追凶故事，读到最后一格才敢呼吸。",
  },
  {
    id: "xiaoyuan",
    name: "校园",
    subtitle: "青春与教室",
    icon: "ri-graduation-cap-line",
    description: "操场、天台与晚自习，青春里那些闪闪发光的瞬间。",
  },
  {
    id: "kehuan",
    name: "科幻",
    subtitle: "未来与星空",
    icon: "ri-rocket-line",
    description: "星际航行、人工智能与时间悖论，望向更远的未来。",
  },
  {
    id: "gufeng",
    name: "古风",
    subtitle: "江湖与朝堂",
    icon: "ri-leaf-line",
    description: "长剑、长街与长安月，东方美学下的江湖与传奇。",
  },
];

export const comicRegions = ["全部", "日本", "韩国", "中国", "欧美"];

export const comicTags = ["全部", "战斗", "成长", "青春", "治愈", "推理", "冒险", "日常", "反差", "群像"];

export const comics = [
  {
    id: "canglan-zhiren",
    title: "苍蓝之刃",
    author: "林野",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20comic%20book%20cover%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20blue%20blade%2C%20dramatic%20wind%2C%20warm%20orange%20accents%2C%20clean%20simple%20background%2C%20bold%20graphic%20style%2C%20high%20detail&width=600&height=800&seq=jm-cover-01&orientation=portrait",
    categoryId: "rexue",
    categoryName: "热血",
    tags: ["战斗", "成长", "群像"],
    region: "日本",
    status: "连载",
    chapterCount: 148,
    latestChapter: "第148话 断刃之后",
    updatedAt: "2026-10-17 09:20",
    viewCount: 1284000,
    likeCount: 96200,
    intro:
      "边境小镇的少年在废墟中捡到一柄会呼吸的刀，从此被卷入两大剑派延续百年的纷争。他不愿成为任何人的武器，只想守住身后那条街。刀锋越亮，代价越重——这是一个关于选择的故事。",
    featured: true,
  },
  {
    id: "xinghuo-jiyuan",
    title: "星火纪元",
    author: "周砚",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20comic%20cover%20art%20of%20a%20space%20pilot%20in%20orange%20suit%20standing%20before%20a%20giant%20starship%2C%20glowing%20engine%20light%2C%20clean%20dark%20simple%20background%2C%20bold%20graphic%20illustration%2C%20high%20detail&width=600&height=800&seq=jm-cover-02&orientation=portrait",
    categoryId: "kehuan",
    categoryName: "科幻",
    tags: ["冒险", "战斗", "群像"],
    region: "中国",
    status: "连载",
    chapterCount: 96,
    latestChapter: "第96话 第七次跃迁",
    updatedAt: "2026-10-17 08:05",
    viewCount: 964000,
    likeCount: 71200,
    intro:
      "人类第一次跃迁失败后，星图上多出一片无人敢进的暗区。一支临时拼凑的救援队带着一艘老旧货船出发，他们要找回的不是飞船，而是被遗忘的那段航行记录。",
    featured: true,
  },
  {
    id: "chunye-gaobai",
    title: "春夜告白信",
    author: "苏晚",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20comic%20cover%20illustration%20of%20two%20high%20school%20students%20under%20cherry%20blossoms%2C%20warm%20pastel%20palette%20with%20orange%20highlights%2C%20clean%20minimal%20background%2C%20delicate%20line%20art%2C%20high%20detail&width=600&height=800&seq=jm-cover-03&orientation=portrait",
    categoryId: "lianai",
    categoryName: "恋爱",
    tags: ["青春", "治愈", "日常"],
    region: "日本",
    status: "连载",
    chapterCount: 64,
    latestChapter: "第64话 迟到的回信",
    updatedAt: "2026-10-16 21:40",
    viewCount: 842000,
    likeCount: 88600,
    intro:
      "转学生把一封没有署名的信塞进了图书室的旧书里，没想到第二天就收到了回信。两个不敢当面说话的人，用一整个春天交换了彼此的日常。",
    featured: true,
  },
  {
    id: "yueguang-yueding",
    title: "月光下的约定",
    author: "许知",
    cover: "https://readdy.ai/api/search-image?query=Enchanting%20fantasy%20comic%20cover%20with%20a%20girl%20in%20a%20flowing%20white%20dress%20standing%20in%20moonlight%2C%20silver%20petals%20floating%2C%20warm%20amber%20glow%2C%20clean%20simple%20background%2C%20elegant%20graphic%20style&width=600&height=800&seq=jm-cover-04&orientation=portrait",
    categoryId: "lianai",
    categoryName: "恋爱",
    tags: ["治愈", "冒险", "青春"],
    region: "韩国",
    status: "连载",
    chapterCount: 82,
    latestChapter: "第82话 月蚀之夜",
    updatedAt: "2026-10-16 19:10",
    viewCount: 731000,
    likeCount: 65300,
    intro:
      "每年中秋，少女都会在旧钟楼等到午夜。传说月光会把等待的人带到想见的人身边，而她已经等了七年。今年，钟楼下站着一个不该出现的身影。",
    featured: false,
  },
  {
    id: "jiuxiao-jiange",
    title: "九霄剑歌",
    author: "白砚川",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20comic%20cover%20painting%20of%20a%20sword%20immortal%20in%20flowing%20robes%20above%20clouds%2C%20ink%20wash%20mountains%2C%20warm%20sunset%20orange%20sky%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=jm-cover-05&orientation=portrait",
    categoryId: "gufeng",
    categoryName: "古风",
    tags: ["战斗", "冒险", "群像"],
    region: "中国",
    status: "连载",
    chapterCount: 210,
    latestChapter: "第210话 剑落九霄",
    updatedAt: "2026-10-16 17:35",
    viewCount: 1582000,
    likeCount: 121800,
    intro:
      "少年剑修被逐出师门那日，师父只留给他一句话：剑不是用来杀人的。十年后他重登九霄，才发现当年那一剑，护住的是整座山门。",
    featured: false,
  },
  {
    id: "miwu-dangan",
    title: "迷雾档案",
    author: "陈默",
    cover: "https://readdy.ai/api/search-image?query=Moody%20mystery%20comic%20cover%20of%20a%20detective%20in%20a%20raincoat%20under%20a%20street%20lamp%2C%20foggy%20alley%2C%20warm%20orange%20light%20beams%2C%20dark%20simple%20background%2C%20graphic%20noir%20illustration&width=600&height=800&seq=jm-cover-06&orientation=portrait",
    categoryId: "xuanyi",
    categoryName: "悬疑",
    tags: ["推理", "反差", "群像"],
    region: "中国",
    status: "连载",
    chapterCount: 118,
    latestChapter: "第118话 第二份证词",
    updatedAt: "2026-10-16 15:00",
    viewCount: 918000,
    likeCount: 74800,
    intro:
      "档案馆最深处有一排没有编号的卷宗，只有三个人有钥匙。当第四个人出现在名单上，一桩被判定为意外的旧案重新开始呼吸。",
    featured: false,
  },
  {
    id: "linju-yaoguai",
    title: "我的邻居是妖怪",
    author: "小满",
    cover: "https://readdy.ai/api/search-image?query=Playful%20urban%20fantasy%20comic%20cover%20of%20a%20cute%20fox%20spirit%20in%20human%20clothes%20peeking%20from%20an%20apartment%20door%2C%20warm%20cozy%20colors%2C%20clean%20minimal%20background%2C%20charming%20graphic%20illustration&width=600&height=800&seq=jm-cover-07&orientation=portrait",
    categoryId: "qihuan",
    categoryName: "奇幻",
    tags: ["日常", "治愈", "反差"],
    region: "韩国",
    status: "连载",
    chapterCount: 76,
    latestChapter: "第76话 台风天的火锅",
    updatedAt: "2026-10-16 12:20",
    viewCount: 604000,
    likeCount: 58200,
    intro:
      "搬进新家的第一晚，隔壁传来奇怪的响动。第二天门口多了一盒热腾腾的饺子，附纸条：昨晚吵到你，抱歉。落款是一只爪印。",
    featured: false,
  },
  {
    id: "quantai-zhiwang",
    title: "拳台之王",
    author: "赵铁",
    cover: "https://readdy.ai/api/search-image?query=Gritty%20boxing%20comic%20cover%20of%20a%20muscular%20fighter%20wrapping%20his%20hands%20in%20the%20ring%2C%20sweat%20and%20warm%20spotlight%2C%20clean%20dark%20background%2C%20bold%20dramatic%20graphic%20style&width=600&height=800&seq=jm-cover-08&orientation=portrait",
    categoryId: "rexue",
    categoryName: "热血",
    tags: ["战斗", "成长", "群像"],
    region: "韩国",
    status: "完结",
    chapterCount: 264,
    latestChapter: "最终话 第十二回合",
    updatedAt: "2026-10-15 22:15",
    viewCount: 1341000,
    likeCount: 104600,
    intro:
      "从地下拳场打到世界擂台，他用了整整十二年。所有人都记得他举起金腰带的那一晚，只有他自己记得，教练在场边说的那句；别急着赢，先把这一拳打完。",
    featured: false,
  },
  {
    id: "shanhai-shitang",
    title: "山海食堂",
    author: "黎小舟",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20fantasy%20food%20comic%20cover%20of%20a%20small%20late%20night%20noodle%20shop%20with%20lantern%20light%20and%20mythical%20creature%20silhouettes%2C%20warm%20orange%20glow%2C%20clean%20simple%20background%2C%20detailed%20illustration&width=600&height=800&seq=jm-cover-09&orientation=portrait",
    categoryId: "qihuan",
    categoryName: "奇幻",
    tags: ["日常", "治愈", "群像"],
    region: "中国",
    status: "连载",
    chapterCount: 132,
    latestChapter: "第132话 一碗忘川面",
    updatedAt: "2026-10-15 20:40",
    viewCount: 712000,
    likeCount: 69400,
    intro:
      "巷子尽头有家只在子时开门的小食堂，老板从不问客人来历。有人说在这里吃到了童年的味道，也有人说，吃完了就再也不想回头。",
    featured: false,
  },
  {
    id: "niguang-erxing",
    title: "逆光而行",
    author: "顾南",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20comic%20cover%20of%20a%20young%20woman%20walking%20through%20a%20sunlit%20city%20street%20with%20long%20warm%20shadows%2C%20clean%20minimal%20composition%2C%20elegant%20graphic%20illustration%2C%20high%20detail&width=600&height=800&seq=jm-cover-10&orientation=portrait",
    categoryId: "dushi",
    categoryName: "都市",
    tags: ["成长", "治愈", "青春"],
    region: "中国",
    status: "连载",
    chapterCount: 58,
    latestChapter: "第58话 天台上的方案",
    updatedAt: "2026-10-15 18:05",
    viewCount: 486000,
    likeCount: 43800,
    intro:
      "三十岁生日那天她辞掉了工作，只带一台旧相机开始记录城市里的普通人。镜头对准别人的时候，她也慢慢看清了自己要走的路。",
    featured: false,
  },
  {
    id: "shijian-zhezhou",
    title: "时间褶皱",
    author: "方屿",
    cover: "https://readdy.ai/api/search-image?query=Surreal%20sci-fi%20comic%20cover%20of%20a%20figure%20standing%20inside%20a%20distorted%20clock%20tunnel%2C%20glowing%20amber%20lines%2C%20clean%20dark%20minimal%20background%2C%20graphic%20concept%20art%2C%20high%20detail&width=600&height=800&seq=jm-cover-11&orientation=portrait",
    categoryId: "kehuan",
    categoryName: "科幻",
    tags: ["推理", "冒险", "反差"],
    region: "欧美",
    status: "连载",
    chapterCount: 44,
    latestChapter: "第44话 第六次回到那天",
    updatedAt: "2026-10-15 16:30",
    viewCount: 392000,
    likeCount: 36700,
    intro:
      "每次闭上眼睛，他都会回到同一天的早上七点。前五次他试图逃走，第六次他决定留下来，看看究竟是什么让这座城市每天准时崩塌。",
    featured: false,
  },
  {
    id: "yuling-shiji",
    title: "御灵师手记",
    author: "白露",
    cover: "https://readdy.ai/api/search-image?query=Oriental%20fantasy%20comic%20cover%20of%20a%20young%20spirit%20master%20with%20glowing%20paper%20talismans%2C%20misty%20bamboo%20forest%2C%20warm%20amber%20and%20ink%20tones%2C%20clean%20composition%2C%20detailed%20art&width=600&height=800&seq=jm-cover-12&orientation=portrait",
    categoryId: "gufeng",
    categoryName: "古风",
    tags: ["冒险", "战斗", "治愈"],
    region: "中国",
    status: "连载",
    chapterCount: 164,
    latestChapter: "第164话 借来的名字",
    updatedAt: "2026-10-15 14:15",
    viewCount: 823000,
    likeCount: 70100,
    intro:
      "御灵师一脉只剩最后一位传人，她的本子上记着三百二十七只灵的名字。每送走一只，纸上就空出一行；直到某天，她写下了自己的名字。",
    featured: false,
  },
  {
    id: "lanqiu-shaonian",
    title: "篮球少年",
    author: "高桥凉",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20sports%20comic%20cover%20of%20a%20teenage%20basketball%20player%20dunking%20under%20warm%20gym%20lights%2C%20dynamic%20motion%2C%20clean%20simple%20background%2C%20bold%20graphic%20illustration%2C%20high%20detail&width=600&height=800&seq=jm-cover-13&orientation=portrait",
    categoryId: "xiaoyuan",
    categoryName: "校园",
    tags: ["青春", "成长", "群像"],
    region: "日本",
    status: "连载",
    chapterCount: 189,
    latestChapter: "第189话 最后一攻",
    updatedAt: "2026-10-14 21:50",
    viewCount: 1096000,
    likeCount: 92700,
    intro:
      "身高一米七的少年想进校队，被拒绝十七次。第十八次他带来了一份写满战术的笔记本，教练翻到最后一页，上面画着全队的名字。",
    featured: false,
  },
  {
    id: "tiandu-chaobiao",
    title: "甜度超标",
    author: "米粒",
    cover: "https://readdy.ai/api/search-image?query=Modern%20romance%20comic%20cover%20of%20a%20couple%20sharing%20ice%20cream%20at%20a%20cafe%20window%2C%20warm%20sunlight%2C%20soft%20pastel%20palette%20with%20orange%20accents%2C%20clean%20minimal%20background%2C%20charming%20illustration&width=600&height=800&seq=jm-cover-14&orientation=portrait",
    categoryId: "lianai",
    categoryName: "恋爱",
    tags: ["日常", "治愈", "反差"],
    region: "中国",
    status: "连载",
    chapterCount: 51,
    latestChapter: "第51话 第二杯半价",
    updatedAt: "2026-10-14 19:25",
    viewCount: 528000,
    likeCount: 61400,
    intro:
      "甜品店店长和每周三准时出现的客人，从点单聊到人生，从草莓塔聊到要不要一起过冬天。所有的喜欢都藏在；今天也要一样的吗。",
    featured: false,
  },
  {
    id: "shenhai-xinbiao",
    title: "深海信标",
    author: "罗盘",
    cover: "https://readdy.ai/api/search-image?query=Deep%20sea%20sci-fi%20comic%20cover%20of%20a%20diver%20descending%20toward%20a%20glowing%20ancient%20beacon%2C%20dark%20water%20with%20warm%20amber%20light%20rays%2C%20clean%20minimal%20composition%2C%20detailed%20artwork&width=600&height=800&seq=jm-cover-15&orientation=portrait",
    categoryId: "xuanyi",
    categoryName: "悬疑",
    tags: ["推理", "冒险", "反差"],
    region: "欧美",
    status: "完结",
    chapterCount: 87,
    latestChapter: "最终话 归航",
    updatedAt: "2026-10-14 16:10",
    viewCount: 674000,
    likeCount: 52300,
    intro:
      "深海考察队在九千米处收到一段规律的信号，频率和二十年前失踪的潜艇一致。他们决定下潜，而海底那盏灯，已经等了很久。",
    featured: false,
  },
  {
    id: "changan-yexing",
    title: "长安夜行录",
    author: "沈墨",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20comic%20cover%2C%20a%20roof%20runner%20with%20a%20lantern%20above%20tiled%20streets%2C%20warm%20orange%20lantern%20glow%2C%20clean%20elegant%20composition%2C%20detailed%20illustration&width=600&height=800&seq=jm-cover-16&orientation=portrait",
    categoryId: "gufeng",
    categoryName: "古风",
    tags: ["推理", "冒险", "群像"],
    region: "中国",
    status: "连载",
    chapterCount: 143,
    latestChapter: "第143话 灯市无名客",
    updatedAt: "2026-10-14 13:45",
    viewCount: 745000,
    likeCount: 63100,
    intro:
      "长安城的宵禁之后，真正的故事才刚开始。夜里替人寻物的少年，收的报酬从来不是钱，而是一个必须讲完的故事。",
    featured: false,
  },
  {
    id: "zhuifeng-shaonv",
    title: "追风少女",
    author: "夏木",
    cover: "https://readdy.ai/api/search-image?query=Youthful%20comic%20cover%20of%20a%20girl%20riding%20a%20bicycle%20down%20a%20seaside%20road%20at%20golden%20hour%2C%20wind%20in%20her%20hair%2C%20clean%20simple%20sky%20background%2C%20bright%20graphic%20illustration&width=600&height=800&seq=jm-cover-17&orientation=portrait",
    categoryId: "xiaoyuan",
    categoryName: "校园",
    tags: ["青春", "成长", "治愈"],
    region: "日本",
    status: "连载",
    chapterCount: 69,
    latestChapter: "第69话 终点不在海边",
    updatedAt: "2026-10-13 20:30",
    viewCount: 441000,
    likeCount: 47200,
    intro:
      "她骑车穿过整座城市，只想在毕业前找到传说中那条没有尽头的路。一路上遇见的人，成了她真正想要保留的风景。",
    featured: false,
  },
  {
    id: "yinhe-lvdian",
    title: "银河旅店",
    author: "苏叶",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20sci-fi%20comic%20cover%20of%20a%20tiny%20hotel%20floating%20in%20space%20with%20warm%20lit%20windows%2C%20a%20traveler%20with%20a%20suitcase%2C%20clean%20starfield%20background%2C%20charming%20graphic%20style&width=600&height=800&seq=jm-cover-18&orientation=portrait",
    categoryId: "kehuan",
    categoryName: "科幻",
    tags: ["日常", "治愈", "群像"],
    region: "欧美",
    status: "连载",
    chapterCount: 35,
    latestChapter: "第35话 第 ∞ 号房客",
    updatedAt: "2026-10-13 17:20",
    viewCount: 318000,
    likeCount: 39600,
    intro:
      "银河边缘有家旅店，只接待迷路的旅人。老板娘说，住满一晚就能找到回家的航线，但没有人问过，她自己为什么不走。",
    featured: false,
  },
  {
    id: "anye-zhentan",
    title: "暗夜侦探社",
    author: "郑一",
    cover: "https://readdy.ai/api/search-image?query=Noir%20detective%20comic%20cover%20of%20a%20young%20investigator%20with%20a%20magnifier%20in%20a%20neon%20lit%20alley%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20clean%20graphic%20illustration%2C%20high%20detail&width=600&height=800&seq=jm-cover-19&orientation=portrait",
    categoryId: "xuanyi",
    categoryName: "悬疑",
    tags: ["推理", "反差", "群像"],
    region: "韩国",
    status: "连载",
    chapterCount: 97,
    latestChapter: "第97话 委托人不在了",
    updatedAt: "2026-10-13 12:00",
    viewCount: 556000,
    likeCount: 48900,
    intro:
      "侦探社只有两个人、一只猫和一台老式打印机。他们接的案子大多很小，直到某天，委托人提前写好了自己的结案报告。",
    featured: false,
  },
  {
    id: "meigui-yutie",
    title: "玫瑰与铁",
    author: "温言",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20historical%20comic%20cover%20of%20a%20noblewoman%20in%20warm%20red%20dress%20holding%20a%20rose%20beside%20an%20armored%20knight%2C%20candlelit%20castle%20background%2C%20elegant%20detailed%20illustration&width=600&height=800&seq=jm-cover-20&orientation=portrait",
    categoryId: "lianai",
    categoryName: "恋爱",
    tags: ["反差", "群像", "成长"],
    region: "欧美",
    status: "完结",
    chapterCount: 122,
    latestChapter: "最终话 春天会来",
    updatedAt: "2026-10-12 22:05",
    viewCount: 689000,
    likeCount: 72500,
    intro:
      "公爵之女被许配给一位从未谋面的骑士。婚礼前夜，她摘下玫瑰，却在盔甲里发现了一封写了十年的信。",
    featured: false,
  },
];

export const heroSlides = [
  {
    comicId: "canglan-zhiren",
    title: "苍蓝之刃",
    subtitle: "本周编辑推荐 · 热血",
    description: "当刀锋响起，少年必须决定自己为何而战。累计阅读 128 万，连载第 148 话已更新。",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20widescreen%20comic%20illustration%20of%20a%20young%20swordsman%20with%20a%20glowing%20blue%20blade%20standing%20on%20a%20cliff%20at%20sunset%2C%20warm%20orange%20sky%2C%20wind%20and%20dust%2C%20cinematic%20lighting%2C%20detailed%20art&width=1600&height=900&seq=jm-hero-01&orientation=landscape",
    accent: "第 148 话已更新",
  },
  {
    comicId: "xinghuo-jiyuan",
    title: "星火纪元",
    subtitle: "科幻新作 · 强势登场",
    description: "一艘旧货船，一支临时队伍，一次无人敢接的跃迁。星图之外的秘密正在等待。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20comic%20banner%20of%20a%20small%20spaceship%20approaching%20a%20vast%20glowing%20nebula%2C%20warm%20amber%20engine%20glow%2C%20deep%20space%2C%20epic%20scale%2C%20detailed%20illustration&width=1600&height=900&seq=jm-hero-02&orientation=landscape",
    accent: "连载第 96 话",
  },
  {
    comicId: "chunye-gaobai",
    title: "春夜告白信",
    subtitle: "高糖恋爱 · 读者票选第一",
    description: "一封没有署名的信，一个不敢开口的春天。慢热治愈，适合深夜一口气读完。",
    image:
      "https://readdy.ai/api/search-image?query=Dreamy%20romantic%20anime%20style%20illustration%20of%20a%20school%20library%20at%20dusk%20with%20cherry%20blossom%20petals%20and%20warm%20orange%20sunlight%20through%20windows%2C%20soft%20cinematic%20atmosphere%2C%20detailed%20art&width=1600&height=900&seq=jm-hero-03&orientation=landscape",
    accent: "第 64 话 迟到的回信",
  },
];